import { auditLogsTableResponseSchema, auditLogsFilterOptionsQuerySchema, auditLogsFilterOptionsResponseSchema, listAuditLogsDataTableParamsSchema, } from '../contracts/audit-logs-table';
import { serializeTableQueryParams } from '../contracts/table';
import { parseSchema } from '../errors';
import { organizationIdSchema, } from '../contracts/organizations';
/**
 * Fetch audit logs in DataTable format (pagination, filters, sorting, search).
 *
 * Sends filters using bracket notation via `serializeTableQueryParams`. The
 * response follows the standard DataTable shape: `{ data, pagination, meta }`.
 */
export async function listAuditLogsDataTable(client, organizationId, params = {}, options) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(listAuditLogsDataTableParamsSchema, params);
    const response = await client.get(`/organizations/${validatedId}/audit-logs/datatable`, {
        params: validatedParams,
        paramsSerializer: serializeTableQueryParams,
        signal: options?.signal,
    });
    return parseSchema(auditLogsTableResponseSchema, response);
}
/**
 * Get distinct filter option values for an audit-log field.
 * Supported fields: tableName, user, changes.
 */
export async function getAuditLogFilterOptions(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(auditLogsFilterOptionsQuerySchema, params);
    const response = await client.get(`/organizations/${validatedId}/audit-logs/filter-options`, { params: validatedParams });
    return parseSchema(auditLogsFilterOptionsResponseSchema, response);
}
//# sourceMappingURL=audit-logs-table.js.map